import { DateTime } from "luxon";
import { DateTimeFormats } from "./datetime.formats";

export const fromGlpiDateToHtmlInputDate = (glpiDate) => {
  return DateTime
    .fromFormat(glpiDate, DateTimeFormats.GLPI_DATETIME)
    .toFormat(DateTimeFormats.HTML_INPUT_DATETIME);
};
